module.exports = __webpack_public_path__ + "MD.png?1abb1cca97d42e96bdac5b71fb310628";